import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@repo/auth';
import { SettingsProvider } from '@repo/settings';
import { Toaster, DeleteConfirmDialog, DialogProvider, toast } from '@repo/ui';
import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { routes } from './navigation/routing';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
    },
  },
});

const RateLimitListener = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleRateLimit = () => {
      toast.error(
        t('common.rateLimitExceeded', {
          defaultValue: 'You are doing that too often. Please wait a moment.',
        })
      );
    };

    window.addEventListener('api:rate-limited', handleRateLimit);
    return () => {
      window.removeEventListener('api:rate-limited', handleRateLimit);
    };
  }, [t]);

  return null;
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <AuthProvider portal="student">
          <DialogProvider>
            <RateLimitListener />
            <RouterProvider router={routes} />
            <DeleteConfirmDialog />
            <Toaster />
          </DialogProvider>
        </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
};

export default App;
